import { MmuTranslateFileLoaderBase, SUPPORTED_LANGUAGE_LOCALES } from '@move/core';
import { from, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';


export class AppTranslateLoader extends MmuTranslateFileLoaderBase {
  constructor() {
    super(SUPPORTED_LANGUAGE_LOCALES);
  }

  protected loadLanguageForLocale(locale: string): Observable<any> {
    /* Loading files via esnext import statement causes webpack to treat them as JS modules. All JSON files in the folder will
     * be loaded as e.g. "1.234234242112.js" in production builds (including the hash for cache busting). */
    const translations = import(
      /* webpackChunkName: "i18n-[request]" */
      `../../../assets/i18n/${locale}.json`
      );
    return from(translations)
    .pipe(catchError((err) => {
      console.error('AppTranslateLoader: Unable to load frontend-container translations for locale', locale, err);
      return of({})
    }));
  }
}
